import {jsonMember, jsonObject} from "typedjson";

/**
 * Базовый класс для опций ui-комопнента.
 * @publicApi
 */
@jsonObject
export class DxBaseUiOptions {
  /**
   * Идентификатор инстанса обекта опций (на случай загрузки из БД).
   * @name _id
   * @type {number}
   * @defaultValue - 0
   */
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: true, isRequired: false})
  private _id: number = 0;

  /**
   * Название виджета.
   * @name _title
   * @type {string}
   */
  @jsonMember({name: "title", constructor: String, emitDefaultValue: true, isRequired: false})
  private _title: string;

  /**
   * Возвращает id инстанса опции.
   * @return {number} - id инстанса опции.
   * @public
   */
  get id(): number {
    return this._id;
  }

  /**
   * Устанавливает id инстанса опции.
   * @param {number} value - значение id инстанса опции.
   * @public
   */
  set id(value: number) {
    this._id = value;
  }

  /**
   * Возвращает название виджета.
   * @return {string} - название виджета.
   * @public
   */
  get title(): string {
    return this._title;
  }

  /**
   * Устанавливает значение названия виджета.
   * @param {string} value - строка с названием виджета.
   * @public
   */
  set title(value: string) {
    this._title = value;
  }
}
